<template>
    <div class="d-sm-flex col-xs-12 cart-item flex-wrap">
        <div @click="remove" class="close cursor-pointer">
            <i class="mdi mdi-close-circle"></i>
        </div>

        <div
            v-if="plan.layout && plan.layout.type === 2"
            class="video d-sm-block col-12 col-sm-4 col-md-3 col-lg-2 px-0"
            v-html="plan.layout.source"
        ></div>
        <img
            v-else
            alt="plan"
            class="
                image
                d-block
                text-center
                img-fluid
                d-sm-block
                col-12
                col-sm-4
                col-md-3
                col-lg-2
                px-0
            "
            :src="
                plan.layout && plan.layout.upload
                    ? image(plan.layout.upload, 'sm')
                    : image(false)
            "
        />

        <div class="flex-grow-1 px-3 m-auto col-12 col-sm-4 col-md-6 col-lg-8">
            <h2>{{ showName }}</h2>
            <p class="mb-0">
                <CartRecurrenceOptions
                    v-if="plan.type === 4 && plan.recurrenceOptions && plan.recurrenceOption"
                    :options="plan.recurrenceOptions"
                    :value="plan.recurrenceOption.id"
                    @select="selectRecurrenceOption"
                />
                <span v-else>{{ $t('cart.type_unique') }}</span>
            </p>
            <div v-if="has_coupon" class="mr-2">
                <span
                    class="cursor-pointer"
                    @click="
                        () => {
                            getCouponCode(), (modal = true);
                        }
                    "
                >
                    {{ $t('cart.coupon.coupon') }}
                    <i class="mdi mdi-ticket-percent"></i>
                </span>
            </div>
        </div>
        <div class="col-12 col-sm-4 col-md-3 col-lg-2 text-center">
            <h2>{{ planPrice }}</h2>
            <span v-if="discount">{{ `- ${discount}` }}</span>
        </div>
        <template v-if="true">
            <Modal
                v-model:show="modal"
                gradient="info"
                modal-classes="modal-danger modal-dialog-centered"
            >
                <div class="py-3 text-center">
                    <i class="mdi mdi-brightness-percent ni-4x"></i>
                    <h4 class="heading mt-4">
                        {{ $t('cart.coupon.has_coupon') }}
                    </h4>
                </div>
                <base-input group class="mb-3">
                    <input
                        type="text"
                        v-model="code"
                        class="form-control"
                        :placeholder="$t('cart.coupon.placeholder')"
                        :aria-label="$t('cart.coupon.placeholder')"
                        :name="$t('cart.code')"
                        :error="errors.first($t('cart.code'))"
                        v-validate="'required'"
                    />
                    <div class="input-group-append">
                        <base-button
                            @click.prevent="validateCupom"
                            :loading="validating"
                            type="success"
                            >{{
                                validating ? '' : $t('cart.coupon.apply')
                            }}</base-button
                        >
                    </div>
                </base-input>
                <span>{{
                    errors.first($t('cart.code')) ? $t('cart.code_empty') : ''
                }}</span>
                <template #footer>
                    <base-button
                        v-if="isCoupon && this.plan.coupon !== null"
                        type="white"
                        @click="removeCoupon"
                        >{{ $t('common.remove') }}</base-button
                    >
                    <base-button
                        type="link"
                        class="ml-auto text-white"
                        @click="modal = false"
                    >
                        {{ $t('common.close') }}
                    </base-button>
                </template>
            </Modal>
        </template>
    </div>
</template>

<script>
import Modal from '../../argon/components/Modal';
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseButton from '../../argon/components/BaseButton';

import CartRecurrenceOptions from './CartRecurrenceOptions';

import Currency from '../../mixins/currency';

import image from '../../mixins/image';

export default {
    name: 'CartItem',
    components: {
        Modal,
        BaseInput,
        BaseButton,
        CartRecurrenceOptions,
    },
    props: {
        plan: {
            type: Object,
        },
        has_coupon: {
            type: Boolean,
        },
        invoice_id: {
            type: String,
        },
    },
    mixins: [Currency, image],
    data() {
        return {
            modal: false,
            validating: false,
            code: '',
        };
    },
    methods: {
        async remove() {
            await this.$store.dispatch('REMOVE_ITEM', this.plan.id);
        },
        async selectRecurrenceOption({ id }) {
            this.$loading.show();
            window.axios
                .put(`api/cart/${this.plan.id}/recurrence-option/apply/${id}`)
                .then(({ data }) => {
                    this.$loading.close();
                    this.$notify({
                        message: this.$t(data.message),
                        type: 'success',
                    });
                    this.$store.commit('SET_CART', {
                        plans: data.items,
                        total: data.total,
                    });
                })
                .catch(({ response }) => {
                    this.$notify({
                        message: this.$t(response.data.message),
                        type: 'danger',
                    });
                    this.$loading.close();
                });
        },
        removeCoupon() {
            this.$store.dispatch('REMOVE_COUPON', {
                code: this.code,
            });
            this.modal = false;
            this.code = '';
        },
        async validateCupom() {
            const valid = await this.$validator.validate();
            if (valid) {
                this.validating = true;
                await this.$store.dispatch('SET_COUPON', {
                    id: this.plan.id,
                    code: this.code,
                });
                this.validating = false;
            }
        },
        getCouponCode() {
            if (this.isCoupon && this.plan.coupon !== null) {
                this.code = this.plan.coupon.code;
            }
        },
    },
    computed: {
        language() {
            return this.$store.getters.LANGUAGE;
        },
        isCoupon() {
            if ('coupon' in this.plan) return true;
            else return false;
        },
        planPrice() {
            return this.plan.price;
        },
        discount() {
            if (this.plan.coupon && this.plan.coupon.type) {
                if (this.plan.coupon.type === 'VALUE') {
                    return this.formatValue(this.plan.coupon.value);
                } else {
                    const discountValue =
                        this.plan.coupon.value * this.plan.value;
                    return this.formatValue(discountValue);
                }
            }
        },
        showName() {
            if (this.plan.translation.name !== null) {
                return this.$findTranslation(this.plan, this.language).name;
            } else if (this.invoice_id) {
                return `${this.$t('billing.invoice.invoice')}: ${this.invoice_id}`;
            }
            return null;
        }
    },
};
</script>

<style scoped>
.cart-item {
    border: 2px solid #ececec;
    border-radius: 7px;
    padding: 10px;
    position: relative;
    width: 100%;
    margin: 15px 0;
}

.image {
    height: auto;
    background-color: #d3d3d3;
    border-radius: 7px;
    object-fit: cover;
    max-height: 300px;
}

.close {
    color: red;
    right: -10px;
    top: -10px;
    position: absolute;
}
</style>

<style>
.video iframe {
    width: 100%;
    height: 100%;
}
</style>
